/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { type FieldContentsData, type IconStructure } from '../../shared-types';
import { FaIcon, type FaIconProps } from '../FaIcon';
import { AhaIcon, type AhaIconProps } from '../AhaIcon';
import { without } from 'lodash';
import { canvasCssValue, parseColorValue } from '@lib/canvasx/util';
import { FlexColumn } from '@lib/canvasx/components/FlexColumn';
import { RECORD_LINE_HEIGHT } from '../../shapes/RecordDecorator';

export const IconField: CanvaSXFC<{
  icon: IconStructure;
  size?: number;
  contents: FieldContentsData;
  fieldId: RecordId;
}> = function (props) {
  let { backgroundColor, color, name, rounded } = props.icon;
  const size = props.size ? props.size : rounded ? 9 : 11;
  const classes = name.trim().split(/\s+/);

  let iconContent: CanvaSXNode;

  // Parse CSS var colors
  color =
    color === undefined
      ? canvasCssValue('--theme-secondary-text', '#666')
      : parseColorValue(color, '#333');

  if (name.includes('fa-')) {
    // FontAwesome icon, normalize/remove extra classes
    const iconName = without(
      classes,
      'fa-regular',
      'fa-solid',
      'fa-fw'
    )[0].replace('fa-', '') as FaIconProps['icon'];

    iconContent = (
      <FaIcon
        color={color}
        icon={iconName}
        size={size}
        style={classes.includes('fa-solid') ? 'solid' : 'regular'}
        lineHeight={RECORD_LINE_HEIGHT}
      />
    );
  } else if (name.includes('aha-icon')) {
    // AhaIcon
    const iconName = without(classes, 'aha-icon', 'fa-fw')[0].replace(
      'aha-icon-',
      ''
    ) as AhaIconProps['icon'];

    iconContent = (
      <AhaIcon
        color={color}
        icon={iconName}
        size={size}
        lineHeight={RECORD_LINE_HEIGHT}
      />
    );
  } else {
    console.error(`Unkown icon: ${name}`);
    return null;
  }

  const fillColor = backgroundColor && parseColorValue(backgroundColor, '');

  return (
    <FlexColumn
      fill={fillColor}
      borderRadius={rounded ? size : undefined}
      width={rounded ? size * 1.6 : undefined}
      height={rounded ? size * 1.6 : undefined}
      horizontalAlignment='center'
    >
      {iconContent}
    </FlexColumn>
  );
};
